__turbopack_context__.v({
  "actions": "NotFoundPage-module-scss-module__e3HPgq__actions",
  "backChevron": "NotFoundPage-module-scss-module__e3HPgq__backChevron",
  "container": "NotFoundPage-module-scss-module__e3HPgq__container",
  "content": "NotFoundPage-module-scss-module__e3HPgq__content",
  "message": "NotFoundPage-module-scss-module__e3HPgq__message",
  "title": "NotFoundPage-module-scss-module__e3HPgq__title",
  "watermark": "NotFoundPage-module-scss-module__e3HPgq__watermark",
});
